import React from 'react';
import { Header } from '../components/landing/Header';
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSolution } from '../components/landing/ProblemSolution';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Testimonials } from '../components/landing/Testimonials';
import { ExpertBacking } from '../components/landing/ExpertBacking';
import { OfferSection } from '../components/landing/OfferSection';
import { Guarantee } from '../components/landing/Guarantee';
import { FAQ } from '../components/landing/FAQ';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';
import { PurchaseNotification } from '../components/ui/PurchaseNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-[#F0FDFA] font-sans text-[#4A3B32]" data-id="element-250">
      <Header data-id="element-251" />
      <main data-id="element-252">
        <HeroSection data-id="element-253" />
        <ProblemSolution data-id="element-254" />
        <HowItWorks data-id="element-255" />
        <Testimonials data-id="element-256" />
        <ExpertBacking data-id="element-257" />
        <OfferSection data-id="element-258" />
        <Guarantee data-id="element-259" />
        <FAQ data-id="element-260" />
        <FinalCTA data-id="element-261" />
      </main>
      <Footer data-id="element-262" />
      <PurchaseNotification data-id="element-263" />
    </div>;
}